import React, { useEffect, useState } from "react";

// Radial SVG gauge (0-100) with animated counter.
export const ScoreGauge = ({ score = 0, label = "", size = 220, animate = true }) => {
  const [display, setDisplay] = useState(animate ? 0 : score);
  const radius = size / 2 - 16;
  const circ = Math.PI * radius; // half circle
  const clamped = Math.max(0, Math.min(100, score));

  useEffect(() => {
    if (!animate) { setDisplay(score); return; }
    let raf;
    const start = performance.now();
    const dur = 1100;
    const step = (t) => {
      const p = Math.min(1, (t - start) / dur);
      const eased = 1 - Math.pow(1 - p, 3);
      setDisplay(Math.round(eased * clamped));
      if (p < 1) raf = requestAnimationFrame(step);
    };
    raf = requestAnimationFrame(step);
    return () => cancelAnimationFrame(raf);
  }, [score, clamped, animate]);

  const color = clamped >= 70 ? "#4A5D23" : clamped >= 55 ? "#C5A059" : clamped >= 40 ? "#B87333" : "#9A3B2E";
  const offset = circ - (display / 100) * circ;

  return (
    <div className="flex flex-col items-center" data-testid="score-gauge">
      <svg width={size} height={size / 2 + 24} viewBox={`0 0 ${size} ${size / 2 + 24}`}>
        <path
          d={`M 16 ${size / 2} A ${radius} ${radius} 0 0 1 ${size - 16} ${size / 2}`}
          fill="none" stroke="#E7E2D6" strokeWidth="14" strokeLinecap="round"
        />
        <path
          d={`M 16 ${size / 2} A ${radius} ${radius} 0 0 1 ${size - 16} ${size / 2}`}
          fill="none" stroke={color} strokeWidth="14" strokeLinecap="round"
          strokeDasharray={circ} strokeDashoffset={offset}
          style={{ transition: "stroke-dashoffset 0.1s linear" }}
        />
      </svg>
      <div className="-mt-14 text-center">
        <div className="font-display font-extrabold text-navy" style={{ fontSize: size * 0.26, lineHeight: 1 }}>
          {display}
        </div>
        <div className="text-muted-foreground text-xs tracking-widest uppercase mt-1">/ 100</div>
      </div>
      {label && <div className="mt-3 font-display font-semibold text-navy text-center">{label}</div>}
    </div>
  );
};
